'use client';

import { Flex, Heading } from '@/_components';
import { useContext, useMemo, type FC } from 'react';
import { UserContext } from '@/_contexts/UserProvider';
import { UserPreviewContext } from '@/_contexts/admin/UserPreviewProvider';
import type { SelectedEntityDisplayProps } from './SelectedEntityDisplay.types.ts';

export const SelectedEntityDisplay: FC<SelectedEntityDisplayProps> = ({
  isPreview = false,
}) => {
  const { company } = useContext(UserContext);
  const { previewCompany } = useContext(UserPreviewContext);

  const dashboardCompany = useMemo(
    () => (isPreview ? previewCompany : company),
    [isPreview, previewCompany, company],
  );

  if (!dashboardCompany?.name) {
    return null;
  }

  return (
    <Flex>
      <Heading level={1}>{dashboardCompany.name}</Heading>
    </Flex>
  );
};
